module.exports = __webpack_public_path__ + "img/levi.0a605b4.jpg";